module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "lxm-transition-fade",
      "mode": "out-in"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "lxm-dialog-container"
  }, [_c('div', {
    staticClass: "lxm-dialog"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    staticClass: "button is-primary lxm-dialog__button",
    on: {
      "click": _vm.closeClicked
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-39a23167", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39a23167!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/LxmDialog.vue
// module id = 838
// module chunks = 0